export const iconFontAwesomeNatureCannabis = (
	<i className="fa-solid fa-cannabis"></i>
);
